import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CACHING_ENABLED } from './caching.tokens';

// caching-strategy.service.ts
@Injectable({ providedIn: 'root' })
export class CachingStrategyService {
  // Match paths owned by the service worker (from ngsw-config)
  private swControlledPaths = ['/loan/api/client', '/loan/api/quote', '/biometric'];

  // Helper: Is this request cacheable by our custom interceptor?
  isCacheable(req: HttpRequest<any>): boolean {
    return req.method === 'GET' &&
      !this.isAuthRequest(req) &&
      !this.isSecure(req) &&
      !this.isServiceWorkerControlled(req) &&
      req.context.get(CACHING_ENABLED) === true;
  }
  isAuthRequest(req: HttpRequest<any>): boolean {
    return req.url.includes('/token') || req.url.includes('/oauth')|| req.url.includes('/uuid');
  }

  isSecure(req: HttpRequest<any>): boolean {
    return req.headers.has('Authorization');
  }

  isServiceWorkerControlled(req: HttpRequest<any>): boolean {
    return this.swControlledPaths.some(path => req.url.includes(path));
  }

  getCacheKey(req: HttpRequest<any>): string {
    return `${req.method}:${req.urlWithParams}`;
  }


  getDefaultTTL(url: string): number {
    if (url.includes('/loan/api/client')) return 5 * 60 * 1000;
    if (url.includes('/dropdowns')) return 10 * 60 * 1000;
    return 30 * 1000;
  }


  isAuthRelated(req: HttpRequest<any>): boolean {
    return req.url.includes('/token') || req.url.includes('/oauth');
  }
}
